/* eslint-disable */
import axios from 'axios';
import config from '@assets/config.json'; // api 请求json  
// 通用 Module 
const state = {
  joinData: null,
}
const mutations = {
  setJoinData(state, data) {
    state.joinData = data;
  },
}
const getters = {
  getJoinData: state => {
    return state.joinData;
  },
}
const actions = {
  getJoinById({ rootState }, id) { // 根据公司Id获取展会信息
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/join?id=${id}`, rootState.header).then(data => {
        console.log("测试：", data)
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  delByCompany({ rootState }, id) { // 根据公司Id删除展会信息
    return new Promise((resolve, reject) => {
      axios.delete(`${config.api.reqApi}/api/join?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getByCompany({ rootState }, opt) { // 根据公司Id获取展会信息
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/join/GetByCompany`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getIndustryListAndChildren({ rootState }) { // （获取类型下的所有展商行业数据
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/Industry/GetListAndChildren`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getIndustryListById({ rootState }, id = '00000000-0000-0000-0000-000000000000') { // 根据父id获取行业
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/Industry/GetByParentId?parentId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve([]);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getExhibitionAll({ rootState }, opt) { // 根据父id获取行业
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/exhibition/GetAll`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getHallByExhibition({ rootState }, id) { // 根据展会Id获取展馆
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/exhall/GetByExhibition?exhibitionId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getCategoryByExhibition({ rootState }, id) { // 根据展会Id获取产品类别
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/category/GetByExhibition?exhibitionId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  }, 
  getCategoryByExhibitionList({ rootState }, id) { // 根据展会Id获取产品类别
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/category/GetAndListByExhibition?exhibitionId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },

  joinExhibition({ rootState }, opt) { // 加入展会
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/join`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  putJoinExhibitionInfo({ rootState }, opt) { // 修改加入展会的信息
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/join`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getExhibitionById({ rootState }, id) { // 根据展会id
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/exhibition?id=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getJoinExhibitionInfoByCompId({ rootState }, opt) { // 通过公司和展会id获取参展信息
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/join/GetByCompId?compId=${opt.compId}&exhibitionId=${opt.exhibitionId}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  setDefaultJoinExhibition({ rootState }, opt) { // 设置公司默认参展信息
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/join/SetDefault`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getCatalogueByJoinId({ rootState }, id) { // 获取会刊信息
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/catalogue/?joinId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getCatalogueCeShi({ rootState }) { //测试
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/catalogueDown/?id=2a00214d-7f55-45aa-9458-74a1ff174f7a`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getCatalogueType({ rootState }) { // 获取会刊企业类别
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/catalogueType/GetList`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  submitCatalogue({ rootState }, opt) { // 提交会刊（新增）
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/catalogue`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  submitCatalogueDown({ rootState }, opt) { // 提交会刊（修改）
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/catalogue`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getCatalogueDown({ rootState }, id) { // 获取会刊修改记录
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/catalogueDown/GetRecord?joinId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getFasciaBoard({ rootState }, id) { // 获取楣板信息
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/lintel/?joinId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getFasciaBoardDown({ rootState }, id) { // 获取楣板修改记录
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/lintelDown/GetRecord?joinId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  submitFasciaBoard({ rootState }, opt) { // 提交楣板（新增）
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/lintel`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  submitFasciaBoardDown({ rootState }, opt) { // 提交楣板（修改）
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/lintel`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getInvoice({ rootState }, id) { // 获取发票信息
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/invoice/getByJoinId?joinId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getInvoiceDown({ rootState }, id) { // 获取发票修改记录
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/invoiceDown/GetRecord?joinId=${id}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  submitInvoice({ rootState }, opt) { // 提交发票（新增）
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/invoice`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  submitInvoiceDown({ rootState }, opt) { // 提交发票（修改）
    return new Promise((resolve, reject) => {
      axios.put(`${config.api.reqApi}/api/invoice`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getCountryList({ rootState }) { // 获取国家列表
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/country/GetList`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getCityList({ rootState }) { // 获取中国省市信息
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/city/GetListAndChildren`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getWeAppCode({ rootState },opt) { // 获取微信小程序码
    // targetType: 目标类型：0公司，1产品，2商机
    // targetId: 目标Id
    // scene: 小程序页面所需场景值
    return new Promise((resolve, reject) => {
      axios.get(`${config.api.reqApi}/api/WeAppSmallCode?targetType=${opt.targetType}&targetId=${opt.targetId}&scene=${opt.scene}`, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getBrand({ rootState },opt) { // 获取品牌
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/brand/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
  getCertificate({ rootState },opt) { // 获取品牌
    return new Promise((resolve, reject) => {
      axios.post(`${config.api.reqApi}/api/Certificate/GetByCompId`, opt, rootState.header).then(data => {
        if (data.data) {
          resolve(data.data);
        } else {
          resolve(null);
        }
      }).catch((err) => {
        console.log(err);
      });
    });
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
} 